import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5001';

const WhatsAppHistory = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRecord, setSelectedRecord] = useState(null);

    useEffect(() => {
        fetchHistory();
    }, []);

    const fetchHistory = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/whatsapp/history`);
            setHistory(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao buscar histórico:', error);
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    if (loading) {
        return <div style={{ padding: '20px' }}>Carregando histórico...</div>;
    }

    return (
        <div>
            <div className="card-header" style={{ marginBottom: '20px' }}>
                <h3><i className="fas fa-history"></i> Histórico de Envios</h3>
                <button
                    className="btn-secondary"
                    onClick={fetchHistory}
                    style={{ padding: '8px 16px' }}
                >
                    <i className="fas fa-sync-alt"></i> Atualizar
                </button>
            </div>

            {history.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                    <i className="fas fa-inbox" style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.3 }}></i>
                    <p>Nenhum envio registrado ainda</p>
                    <p style={{ fontSize: '0.9rem' }}>Os envios aparecerão aqui após você enviar ofertas para grupos</p>
                </div>
            ) : (
                <div className="offer-table-container" style={{ boxShadow: 'none', padding: 0 }}>
                    <table>
                        <thead>
                            <tr>
                                <th>Data/Hora</th>
                                <th>Tipo</th>
                                <th>Destino</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((record, index) => (
                                <tr key={index}>
                                    <td>
                                        <div style={{ fontSize: '0.9rem' }}>
                                            {formatDate(record.timestamp)}
                                        </div>
                                    </td>
                                    <td>
                                        <span style={{
                                            backgroundColor: '#e9ecef',
                                            padding: '4px 8px',
                                            borderRadius: '12px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600'
                                        }}>
                                            {record.type === 'offer' ? 'Oferta' : 'Mensagem'}
                                        </span>
                                    </td>
                                    <td>
                                        <span style={{ fontSize: '0.9rem' }}>
                                            {record.target ? record.target.substring(0, 20) + '...' : 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        {record.success ? (
                                            <span style={{
                                                backgroundColor: 'rgba(0, 166, 80, 0.1)',
                                                color: '#00a650',
                                                padding: '4px 12px',
                                                borderRadius: '12px',
                                                fontSize: '0.85rem',
                                                fontWeight: '600'
                                            }}>
                                                Sucesso
                                            </span>
                                        ) : (
                                            <span style={{
                                                backgroundColor: 'rgba(255, 59, 60, 0.1)',
                                                color: '#ff3b3c',
                                                padding: '4px 12px',
                                                borderRadius: '12px',
                                                fontSize: '0.85rem',
                                                fontWeight: '600'
                                            }}>
                                                Falhou
                                            </span>
                                        )}
                                    </td>
                                    <td className="actions">
                                        <button
                                            className="btn-secondary"
                                            onClick={() => setSelectedRecord(record)}
                                            style={{
                                                padding: '6px 12px',
                                                fontSize: '0.85rem',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '5px'
                                            }}
                                        >
                                            <i className="fas fa-eye"></i> Detalhes
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal de Detalhes */}
            {selectedRecord && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '30px',
                        maxWidth: '700px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflow: 'auto'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0 }}>
                                <i className="fas fa-info-circle"></i> Detalhes do Envio
                            </h3>
                            <button
                                onClick={() => setSelectedRecord(null)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <p><strong>Data/Hora:</strong> {formatDate(selectedRecord.timestamp)}</p>
                            <p><strong>Tipo:</strong> {selectedRecord.type}</p>
                            <p><strong>Destino:</strong> {selectedRecord.target}</p>
                            <p><strong>Status:</strong> {selectedRecord.success ? <span style={{ color: '#00a650' }}>Sucesso</span> : <span style={{ color: '#ff3b3c' }}>Falha</span>}</p>
                            {selectedRecord.error && (
                                <p><strong>Erro:</strong> <span style={{ color: '#ff3b3c' }}>{selectedRecord.error}</span></p>
                            )}
                        </div>

                        <button
                            className="btn-secondary"
                            onClick={() => setSelectedRecord(null)}
                            style={{ width: '100%' }}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WhatsAppHistory;
